export default {"src":"/_next/static/media/file.80450903.svg","height":24,"width":24};